import { Languages } from 'lucide-react';

import { useI18n, useLanguage } from '../../i18n/I18nProvider';
import { cn } from '../../lib/cn';

// Alterna el idioma (es ↔ en) y muestra el código actual. `tone="onDark"` para
// fondos oscuros (header verde); `default` para superficies claras/oscuras.
export function LanguageToggle({
  tone = 'default',
  className,
}: {
  tone?: 'onDark' | 'default';
  className?: string;
}): JSX.Element {
  const { lang, setLanguage } = useLanguage();
  const t = useI18n();

  return (
    <button
      type="button"
      onClick={() => setLanguage(lang === 'es' ? 'en' : 'es')}
      aria-label={t.idioma.cambiar}
      title={t.idioma.cambiar}
      className={cn(
        'inline-flex h-9 items-center justify-center gap-1.5 rounded-md px-2 text-xs font-semibold uppercase transition-colors focus-visible:outline-none focus-visible:ring-2',
        tone === 'onDark'
          ? 'text-white/80 hover:bg-white/10 hover:text-white focus-visible:ring-white/60'
          : 'text-text-subtle hover:bg-surface-muted hover:text-text-strong focus-visible:ring-marca-primario',
        className,
      )}
    >
      <Languages size={16} />
      {lang}
    </button>
  );
}
